/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as UpgradeRouteImport } from './routes/upgrade'
import { Route as SetupAccountRouteImport } from './routes/setup-account'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as RegisterRouteImport } from './routes/register'
import { Route as LoginRouteImport } from './routes/login'
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password'
import { Route as DashboardRouteImport } from './routes/dashboard'
import { Route as AdminLoginRouteImport } from './routes/admin-login'
import { Route as AdminRouteImport } from './routes/admin'
import { Route as IndexRouteImport } from './routes/index'
import { Route as DashboardIndexRouteImport } from './routes/dashboard/index'
import { Route as AdminIndexRouteImport } from './routes/admin/index'
import { Route as SetupProfileRouteImport } from './routes/setup.profile'
import { Route as SetupCompanyRouteImport } from './routes/setup.company'
import { Route as DashboardSubscriptionRouteImport } from './routes/dashboard/subscription'
import { Route as DashboardSettingsRouteImport } from './routes/dashboard/settings'
import { Route as DashboardOrganizerRouteImport } from './routes/dashboard/organizer'
import { Route as DashboardMenuRouteImport } from './routes/dashboard/menu'
import { Route as DashboardGroupsRouteImport } from './routes/dashboard/groups'
import { Route as DashboardEarningsRouteImport } from './routes/dashboard/earnings'
import { Route as DashboardBusinessRouteImport } from './routes/dashboard/business'
import { Route as DashboardActionsRouteImport } from './routes/dashboard/actions'
import { Route as AdminStatsRouteImport } from './routes/admin/stats'
import { Route as AdminSignupsRouteImport } from './routes/admin/signups'
import { Route as AdminShareCashbackRouteImport } from './routes/admin/share-cashback'
import { Route as AdminOpportunitiesRouteImport } from './routes/admin/opportunities'
import { Route as AdminModerationRouteImport } from './routes/admin/moderation'
import { Route as AdminMapRouteImport } from './routes/admin/map'
import { Route as AdminInviteBusinessRouteImport } from './routes/admin/invite-business'
import { Route as AdminDropsRouteImport } from './routes/admin/drops'
import { Route as AdminDownloadLinksRouteImport } from './routes/admin/download-links'
import { Route as AdminContentReportsRouteImport } from './routes/admin/content-reports'
import { Route as AdminChannelRouteImport } from './routes/admin/channel'
import { Route as AdminAiCostsRouteImport } from './routes/admin/ai-costs'
import { Route as DashboardMediaIndexRouteImport } from './routes/dashboard/media/index'
import { Route as DashboardListingsIndexRouteImport } from './routes/dashboard/listings/index'
import { Route as DashboardEventsIndexRouteImport } from './routes/dashboard/events/index'
import { Route as DashboardCrosspostingIndexRouteImport } from './routes/dashboard/crossposting/index'
import { Route as DashboardAiStudioIndexRouteImport } from './routes/dashboard/ai-studio/index'
import { Route as AdminPartnersIndexRouteImport } from './routes/admin/partners.index'
import { Route as DashboardListingsCreateRouteImport } from './routes/dashboard/listings/create'
import { Route as DashboardEventsCreateRouteImport } from './routes/dashboard/events/create'
import { Route as DashboardBusinessEditRouteImport } from './routes/dashboard/business/edit'
import { Route as DashboardAiStudioRefineRouteImport } from './routes/dashboard/ai-studio/refine'
import { Route as DashboardAiStudioQrRouteImport } from './routes/dashboard/ai-studio/qr'
import { Route as DashboardAiStudioFormatConverterRouteImport } from './routes/dashboard/ai-studio/format-converter'
import { Route as DashboardAiStudioFlyerRouteImport } from './routes/dashboard/ai-studio/flyer'
import { Route as DashboardAiStudioEventCreatorRouteImport } from './routes/dashboard/ai-studio/event-creator'
import { Route as DashboardAiStudioEditPictureRouteImport } from './routes/dashboard/ai-studio/edit-picture'
import { Route as AdminPartnersPartnerIdRouteImport } from './routes/admin/partners.$partnerId'
import { Route as DashboardListingsListingIdIndexRouteImport } from './routes/dashboard/listings/$listingId.index'
import { Route as DashboardEventsEventIdIndexRouteImport } from './routes/dashboard/events/$eventId.index'
import { Route as DashboardCrosspostingListingIdIndexRouteImport } from './routes/dashboard/crossposting/$listingId.index'
import { Route as DashboardListingsListingIdEditRouteImport } from './routes/dashboard/listings/$listingId.edit'
import { Route as DashboardEventsEventIdTicketsRouteImport } from './routes/dashboard/events/$eventId.tickets'
import { Route as DashboardEventsEventIdRequestsRouteImport } from './routes/dashboard/events/$eventId.requests'
import { Route as DashboardEventsEventIdEditRouteImport } from './routes/dashboard/events/$eventId.edit'
import { Route as DashboardCrosspostingListingIdOverviewRouteImport } from './routes/dashboard/crossposting/$listingId.overview'
import { Route as DashboardCrosspostingListingIdInstagramRouteImport } from './routes/dashboard/crossposting/$listingId.instagram'
import { Route as DashboardCrosspostingListingIdFacebookRouteImport } from './routes/dashboard/crossposting/$listingId.facebook'
import { Route as DashboardCrosspostingListingIdCrossPostRouteImport } from './routes/dashboard/crossposting/$listingId.cross-post'
import { Route as DashboardCrosspostingListingIdConnectRouteImport } from './routes/dashboard/crossposting/$listingId.connect'

const UpgradeRoute = UpgradeRouteImport.update({
  id: '/upgrade',
  path: '/upgrade',
  getParentRoute: () => rootRouteImport,
} as any)
const SetupAccountRoute = SetupAccountRouteImport.update({
  id: '/setup-account',
  path: '/setup-account',
  getParentRoute: () => rootRouteImport,
} as any)
const ResetPasswordRoute = ResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRouteImport,
} as any)
const RegisterRoute = RegisterRouteImport.update({
  id: '/register',
  path: '/register',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardRoute = DashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminLoginRoute = AdminLoginRouteImport.update({
  id: '/admin-login',
  path: '/admin-login',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminRoute = AdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardIndexRoute = DashboardIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => DashboardRoute,
} as any)
const AdminIndexRoute = AdminIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminRoute,
} as any)
const SetupProfileRoute = SetupProfileRouteImport.update({
  id: '/setup/profile',
  path: '/setup/profile',
  getParentRoute: () => rootRouteImport,
} as any)
const SetupCompanyRoute = SetupCompanyRouteImport.update({
  id: '/setup/company',
  path: '/setup/company',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardSubscriptionRoute = DashboardSubscriptionRouteImport.update({
  id: '/subscription',
  path: '/subscription',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardSettingsRoute = DashboardSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardOrganizerRoute = DashboardOrganizerRouteImport.update({
  id: '/organizer',
  path: '/organizer',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardMenuRoute = DashboardMenuRouteImport.update({
  id: '/menu',
  path: '/menu',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardGroupsRoute = DashboardGroupsRouteImport.update({
  id: '/groups',
  path: '/groups',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardEarningsRoute = DashboardEarningsRouteImport.update({
  id: '/earnings',
  path: '/earnings',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardBusinessRoute = DashboardBusinessRouteImport.update({
  id: '/business',
  path: '/business',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardActionsRoute = DashboardActionsRouteImport.update({
  id: '/actions',
  path: '/actions',
  getParentRoute: () => DashboardRoute,
} as any)
const AdminStatsRoute = AdminStatsRouteImport.update({
  id: '/stats',
  path: '/stats',
  getParentRoute: () => AdminRoute,
} as any)
const AdminSignupsRoute = AdminSignupsRouteImport.update({
  id: '/signups',
  path: '/signups',
  getParentRoute: () => AdminRoute,
} as any)
const AdminShareCashbackRoute = AdminShareCashbackRouteImport.update({
  id: '/share-cashback',
  path: '/share-cashback',
  getParentRoute: () => AdminRoute,
} as any)
const AdminOpportunitiesRoute = AdminOpportunitiesRouteImport.update({
  id: '/opportunities',
  path: '/opportunities',
  getParentRoute: () => AdminRoute,
} as any)
const AdminModerationRoute = AdminModerationRouteImport.update({
  id: '/moderation',
  path: '/moderation',
  getParentRoute: () => AdminRoute,
} as any)
const AdminMapRoute = AdminMapRouteImport.update({
  id: '/map',
  path: '/map',
  getParentRoute: () => AdminRoute,
} as any)
const AdminInviteBusinessRoute = AdminInviteBusinessRouteImport.update({
  id: '/invite-business',
  path: '/invite-business',
  getParentRoute: () => AdminRoute,
} as any)
const AdminDropsRoute = AdminDropsRouteImport.update({
  id: '/drops',
  path: '/drops',
  getParentRoute: () => AdminRoute,
} as any)
const AdminDownloadLinksRoute = AdminDownloadLinksRouteImport.update({
  id: '/download-links',
  path: '/download-links',
  getParentRoute: () => AdminRoute,
} as any)
const AdminContentReportsRoute = AdminContentReportsRouteImport.update({
  id: '/content-reports',
  path: '/content-reports',
  getParentRoute: () => AdminRoute,
} as any)
const AdminChannelRoute = AdminChannelRouteImport.update({
  id: '/channel',
  path: '/channel',
  getParentRoute: () => AdminRoute,
} as any)
const AdminAiCostsRoute = AdminAiCostsRouteImport.update({
  id: '/ai-costs',
  path: '/ai-costs',
  getParentRoute: () => AdminRoute,
} as any)
const DashboardMediaIndexRoute = DashboardMediaIndexRouteImport.update({
  id: '/media/',
  path: '/media/',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardListingsIndexRoute = DashboardListingsIndexRouteImport.update({
  id: '/listings/',
  path: '/listings/',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardEventsIndexRoute = DashboardEventsIndexRouteImport.update({
  id: '/events/',
  path: '/events/',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardCrosspostingIndexRoute =
  DashboardCrosspostingIndexRouteImport.update({
    id: '/crossposting/',
    path: '/crossposting/',
    getParentRoute: () => DashboardRoute,
  } as any)
const DashboardAiStudioIndexRoute = DashboardAiStudioIndexRouteImport.update({
  id: '/ai-studio/',
  path: '/ai-studio/',
  getParentRoute: () => DashboardRoute,
} as any)
const AdminPartnersIndexRoute = AdminPartnersIndexRouteImport.update({
  id: '/partners/',
  path: '/partners/',
  getParentRoute: () => AdminRoute,
} as any)
const DashboardListingsCreateRoute = DashboardListingsCreateRouteImport.update({
  id: '/listings/create',
  path: '/listings/create',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardEventsCreateRoute = DashboardEventsCreateRouteImport.update({
  id: '/events/create',
  path: '/events/create',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardBusinessEditRoute = DashboardBusinessEditRouteImport.update({
  id: '/edit',
  path: '/edit',
  getParentRoute: () => DashboardBusinessRoute,
} as any)
const DashboardAiStudioRefineRoute = DashboardAiStudioRefineRouteImport.update({
  id: '/ai-studio/refine',
  path: '/ai-studio/refine',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardAiStudioQrRoute = DashboardAiStudioQrRouteImport.update({
  id: '/ai-studio/qr',
  path: '/ai-studio/qr',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardAiStudioFormatConverterRoute =
  DashboardAiStudioFormatConverterRouteImport.update({
    id: '/ai-studio/format-converter',
    path: '/ai-studio/format-converter',
    getParentRoute: () => DashboardRoute,
  } as any)
const DashboardAiStudioFlyerRoute = DashboardAiStudioFlyerRouteImport.update({
  id: '/ai-studio/flyer',
  path: '/ai-studio/flyer',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardAiStudioEventCreatorRoute =
  DashboardAiStudioEventCreatorRouteImport.update({
    id: '/ai-studio/event-creator',
    path: '/ai-studio/event-creator',
    getParentRoute: () => DashboardRoute,
  } as any)
const DashboardAiStudioEditPictureRoute =
  DashboardAiStudioEditPictureRouteImport.update({
    id: '/ai-studio/edit-picture',
    path: '/ai-studio/edit-picture',
    getParentRoute: () => DashboardRoute,
  } as any)
const AdminPartnersPartnerIdRoute = AdminPartnersPartnerIdRouteImport.update({
  id: '/partners/$partnerId',
  path: '/partners/$partnerId',
  getParentRoute: () => AdminRoute,
} as any)
const DashboardListingsListingIdIndexRoute =
  DashboardListingsListingIdIndexRouteImport.update({
    id: '/listings/$listingId/',
    path: '/listings/$listingId/',
    getParentRoute: () => DashboardRoute,
  } as any)
const DashboardEventsEventIdIndexRoute =
  DashboardEventsEventIdIndexRouteImport.update({
    id: '/events/$eventId/',
    path: '/events/$eventId/',
    getParentRoute: () => DashboardRoute,
  } as any)
const DashboardCrosspostingListingIdIndexRoute =
  DashboardCrosspostingListingIdIndexRouteImport.update({
    id: '/crossposting/$listingId/',
    path: '/crossposting/$listingId/',
    getParentRoute: () => DashboardRoute,
  } as any)
const DashboardListingsListingIdEditRoute =
  DashboardListingsListingIdEditRouteImport.update({
    id: '/listings/$listingId/edit',
    path: '/listings/$listingId/edit',
    getParentRoute: () => DashboardRoute,
  } as any)
const DashboardEventsEventIdTicketsRoute =
  DashboardEventsEventIdTicketsRouteImport.update({
    id: '/events/$eventId/tickets',
    path: '/events/$eventId/tickets',
    getParentRoute: () => DashboardRoute,
  } as any)
const DashboardEventsEventIdRequestsRoute =
  DashboardEventsEventIdRequestsRouteImport.update({
    id: '/events/$eventId/requests',
    path: '/events/$eventId/requests',
    getParentRoute: () => DashboardRoute,
  } as any)
const DashboardEventsEventIdEditRoute =
  DashboardEventsEventIdEditRouteImport.update({
    id: '/events/$eventId/edit',
    path: '/events/$eventId/edit',
    getParentRoute: () => DashboardRoute,
  } as any)
const DashboardCrosspostingListingIdOverviewRoute =
  DashboardCrosspostingListingIdOverviewRouteImport.update({
    id: '/crossposting/$listingId/overview',
    path: '/crossposting/$listingId/overview',
    getParentRoute: () => DashboardRoute,
  } as any)
const DashboardCrosspostingListingIdInstagramRoute =
  DashboardCrosspostingListingIdInstagramRouteImport.update({
    id: '/crossposting/$listingId/instagram',
    path: '/crossposting/$listingId/instagram',
    getParentRoute: () => DashboardRoute,
  } as any)
const DashboardCrosspostingListingIdFacebookRoute =
  DashboardCrosspostingListingIdFacebookRouteImport.update({
    id: '/crossposting/$listingId/facebook',
    path: '/crossposting/$listingId/facebook',
    getParentRoute: () => DashboardRoute,
  } as any)
const DashboardCrosspostingListingIdCrossPostRoute =
  DashboardCrosspostingListingIdCrossPostRouteImport.update({
    id: '/crossposting/$listingId/cross-post',
    path: '/crossposting/$listingId/cross-post',
    getParentRoute: () => DashboardRoute,
  } as any)
const DashboardCrosspostingListingIdConnectRoute =
  DashboardCrosspostingListingIdConnectRouteImport.update({
    id: '/crossposting/$listingId/connect',
    path: '/crossposting/$listingId/connect',
    getParentRoute: () => DashboardRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/admin': typeof AdminRouteWithChildren
  '/admin-login': typeof AdminLoginRoute
  '/dashboard': typeof DashboardRouteWithChildren
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/register': typeof RegisterRoute
  '/reset-password': typeof ResetPasswordRoute
  '/setup-account': typeof SetupAccountRoute
  '/upgrade': typeof UpgradeRoute
  '/admin/ai-costs': typeof AdminAiCostsRoute
  '/admin/channel': typeof AdminChannelRoute
  '/admin/content-reports': typeof AdminContentReportsRoute
  '/admin/download-links': typeof AdminDownloadLinksRoute
  '/admin/drops': typeof AdminDropsRoute
  '/admin/invite-business': typeof AdminInviteBusinessRoute
  '/admin/map': typeof AdminMapRoute
  '/admin/moderation': typeof AdminModerationRoute
  '/admin/opportunities': typeof AdminOpportunitiesRoute
  '/admin/share-cashback': typeof AdminShareCashbackRoute
  '/admin/signups': typeof AdminSignupsRoute
  '/admin/stats': typeof AdminStatsRoute
  '/dashboard/actions': typeof DashboardActionsRoute
  '/dashboard/business': typeof DashboardBusinessRouteWithChildren
  '/dashboard/earnings': typeof DashboardEarningsRoute
  '/dashboard/groups': typeof DashboardGroupsRoute
  '/dashboard/menu': typeof DashboardMenuRoute
  '/dashboard/organizer': typeof DashboardOrganizerRoute
  '/dashboard/settings': typeof DashboardSettingsRoute
  '/dashboard/subscription': typeof DashboardSubscriptionRoute
  '/setup/company': typeof SetupCompanyRoute
  '/setup/profile': typeof SetupProfileRoute
  '/admin/': typeof AdminIndexRoute
  '/dashboard/': typeof DashboardIndexRoute
  '/admin/partners/$partnerId': typeof AdminPartnersPartnerIdRoute
  '/dashboard/ai-studio/edit-picture': typeof DashboardAiStudioEditPictureRoute
  '/dashboard/ai-studio/event-creator': typeof DashboardAiStudioEventCreatorRoute
  '/dashboard/ai-studio/flyer': typeof DashboardAiStudioFlyerRoute
  '/dashboard/ai-studio/format-converter': typeof DashboardAiStudioFormatConverterRoute
  '/dashboard/ai-studio/qr': typeof DashboardAiStudioQrRoute
  '/dashboard/ai-studio/refine': typeof DashboardAiStudioRefineRoute
  '/dashboard/business/edit': typeof DashboardBusinessEditRoute
  '/dashboard/events/create': typeof DashboardEventsCreateRoute
  '/dashboard/listings/create': typeof DashboardListingsCreateRoute
  '/admin/partners/': typeof AdminPartnersIndexRoute
  '/dashboard/ai-studio/': typeof DashboardAiStudioIndexRoute
  '/dashboard/crossposting/': typeof DashboardCrosspostingIndexRoute
  '/dashboard/events/': typeof DashboardEventsIndexRoute
  '/dashboard/listings/': typeof DashboardListingsIndexRoute
  '/dashboard/media/': typeof DashboardMediaIndexRoute
  '/dashboard/crossposting/$listingId/connect': typeof DashboardCrosspostingListingIdConnectRoute
  '/dashboard/crossposting/$listingId/cross-post': typeof DashboardCrosspostingListingIdCrossPostRoute
  '/dashboard/crossposting/$listingId/facebook': typeof DashboardCrosspostingListingIdFacebookRoute
  '/dashboard/crossposting/$listingId/instagram': typeof DashboardCrosspostingListingIdInstagramRoute
  '/dashboard/crossposting/$listingId/overview': typeof DashboardCrosspostingListingIdOverviewRoute
  '/dashboard/events/$eventId/edit': typeof DashboardEventsEventIdEditRoute
  '/dashboard/events/$eventId/requests': typeof DashboardEventsEventIdRequestsRoute
  '/dashboard/events/$eventId/tickets': typeof DashboardEventsEventIdTicketsRoute
  '/dashboard/listings/$listingId/edit': typeof DashboardListingsListingIdEditRoute
  '/dashboard/crossposting/$listingId/': typeof DashboardCrosspostingListingIdIndexRoute
  '/dashboard/events/$eventId/': typeof DashboardEventsEventIdIndexRoute
  '/dashboard/listings/$listingId/': typeof DashboardListingsListingIdIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/admin-login': typeof AdminLoginRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/register': typeof RegisterRoute
  '/reset-password': typeof ResetPasswordRoute
  '/setup-account': typeof SetupAccountRoute
  '/upgrade': typeof UpgradeRoute
  '/admin/ai-costs': typeof AdminAiCostsRoute
  '/admin/channel': typeof AdminChannelRoute
  '/admin/content-reports': typeof AdminContentReportsRoute
  '/admin/download-links': typeof AdminDownloadLinksRoute
  '/admin/drops': typeof AdminDropsRoute
  '/admin/invite-business': typeof AdminInviteBusinessRoute
  '/admin/map': typeof AdminMapRoute
  '/admin/moderation': typeof AdminModerationRoute
  '/admin/opportunities': typeof AdminOpportunitiesRoute
  '/admin/share-cashback': typeof AdminShareCashbackRoute
  '/admin/signups': typeof AdminSignupsRoute
  '/admin/stats': typeof AdminStatsRoute
  '/dashboard/actions': typeof DashboardActionsRoute
  '/dashboard/business': typeof DashboardBusinessRouteWithChildren
  '/dashboard/earnings': typeof DashboardEarningsRoute
  '/dashboard/groups': typeof DashboardGroupsRoute
  '/dashboard/menu': typeof DashboardMenuRoute
  '/dashboard/organizer': typeof DashboardOrganizerRoute
  '/dashboard/settings': typeof DashboardSettingsRoute
  '/dashboard/subscription': typeof DashboardSubscriptionRoute
  '/setup/company': typeof SetupCompanyRoute
  '/setup/profile': typeof SetupProfileRoute
  '/admin': typeof AdminIndexRoute
  '/dashboard': typeof DashboardIndexRoute
  '/admin/partners/$partnerId': typeof AdminPartnersPartnerIdRoute
  '/dashboard/ai-studio/edit-picture': typeof DashboardAiStudioEditPictureRoute
  '/dashboard/ai-studio/event-creator': typeof DashboardAiStudioEventCreatorRoute
  '/dashboard/ai-studio/flyer': typeof DashboardAiStudioFlyerRoute
  '/dashboard/ai-studio/format-converter': typeof DashboardAiStudioFormatConverterRoute
  '/dashboard/ai-studio/qr': typeof DashboardAiStudioQrRoute
  '/dashboard/ai-studio/refine': typeof DashboardAiStudioRefineRoute
  '/dashboard/business/edit': typeof DashboardBusinessEditRoute
  '/dashboard/events/create': typeof DashboardEventsCreateRoute
  '/dashboard/listings/create': typeof DashboardListingsCreateRoute
  '/admin/partners': typeof AdminPartnersIndexRoute
  '/dashboard/ai-studio': typeof DashboardAiStudioIndexRoute
  '/dashboard/crossposting': typeof DashboardCrosspostingIndexRoute
  '/dashboard/events': typeof DashboardEventsIndexRoute
  '/dashboard/listings': typeof DashboardListingsIndexRoute
  '/dashboard/media': typeof DashboardMediaIndexRoute
  '/dashboard/crossposting/$listingId/connect': typeof DashboardCrosspostingListingIdConnectRoute
  '/dashboard/crossposting/$listingId/cross-post': typeof DashboardCrosspostingListingIdCrossPostRoute
  '/dashboard/crossposting/$listingId/facebook': typeof DashboardCrosspostingListingIdFacebookRoute
  '/dashboard/crossposting/$listingId/instagram': typeof DashboardCrosspostingListingIdInstagramRoute
  '/dashboard/crossposting/$listingId/overview': typeof DashboardCrosspostingListingIdOverviewRoute
  '/dashboard/events/$eventId/edit': typeof DashboardEventsEventIdEditRoute
  '/dashboard/events/$eventId/requests': typeof DashboardEventsEventIdRequestsRoute
  '/dashboard/events/$eventId/tickets': typeof DashboardEventsEventIdTicketsRoute
  '/dashboard/listings/$listingId/edit': typeof DashboardListingsListingIdEditRoute
  '/dashboard/crossposting/$listingId': typeof DashboardCrosspostingListingIdIndexRoute
  '/dashboard/events/$eventId': typeof DashboardEventsEventIdIndexRoute
  '/dashboard/listings/$listingId': typeof DashboardListingsListingIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/admin': typeof AdminRouteWithChildren
  '/admin-login': typeof AdminLoginRoute
  '/dashboard': typeof DashboardRouteWithChildren
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/register': typeof RegisterRoute
  '/reset-password': typeof ResetPasswordRoute
  '/setup-account': typeof SetupAccountRoute
  '/upgrade': typeof UpgradeRoute
  '/admin/ai-costs': typeof AdminAiCostsRoute
  '/admin/channel': typeof AdminChannelRoute
  '/admin/content-reports': typeof AdminContentReportsRoute
  '/admin/download-links': typeof AdminDownloadLinksRoute
  '/admin/drops': typeof AdminDropsRoute
  '/admin/invite-business': typeof AdminInviteBusinessRoute
  '/admin/map': typeof AdminMapRoute
  '/admin/moderation': typeof AdminModerationRoute
  '/admin/opportunities': typeof AdminOpportunitiesRoute
  '/admin/share-cashback': typeof AdminShareCashbackRoute
  '/admin/signups': typeof AdminSignupsRoute
  '/admin/stats': typeof AdminStatsRoute
  '/dashboard/actions': typeof DashboardActionsRoute
  '/dashboard/business': typeof DashboardBusinessRouteWithChildren
  '/dashboard/earnings': typeof DashboardEarningsRoute
  '/dashboard/groups': typeof DashboardGroupsRoute
  '/dashboard/menu': typeof DashboardMenuRoute
  '/dashboard/organizer': typeof DashboardOrganizerRoute
  '/dashboard/settings': typeof DashboardSettingsRoute
  '/dashboard/subscription': typeof DashboardSubscriptionRoute
  '/setup/company': typeof SetupCompanyRoute
  '/setup/profile': typeof SetupProfileRoute
  '/admin/': typeof AdminIndexRoute
  '/dashboard/': typeof DashboardIndexRoute
  '/admin/partners/$partnerId': typeof AdminPartnersPartnerIdRoute
  '/dashboard/ai-studio/edit-picture': typeof DashboardAiStudioEditPictureRoute
  '/dashboard/ai-studio/event-creator': typeof DashboardAiStudioEventCreatorRoute
  '/dashboard/ai-studio/flyer': typeof DashboardAiStudioFlyerRoute
  '/dashboard/ai-studio/format-converter': typeof DashboardAiStudioFormatConverterRoute
  '/dashboard/ai-studio/qr': typeof DashboardAiStudioQrRoute
  '/dashboard/ai-studio/refine': typeof DashboardAiStudioRefineRoute
  '/dashboard/business/edit': typeof DashboardBusinessEditRoute
  '/dashboard/events/create': typeof DashboardEventsCreateRoute
  '/dashboard/listings/create': typeof DashboardListingsCreateRoute
  '/admin/partners/': typeof AdminPartnersIndexRoute
  '/dashboard/ai-studio/': typeof DashboardAiStudioIndexRoute
  '/dashboard/crossposting/': typeof DashboardCrosspostingIndexRoute
  '/dashboard/events/': typeof DashboardEventsIndexRoute
  '/dashboard/listings/': typeof DashboardListingsIndexRoute
  '/dashboard/media/': typeof DashboardMediaIndexRoute
  '/dashboard/crossposting/$listingId/connect': typeof DashboardCrosspostingListingIdConnectRoute
  '/dashboard/crossposting/$listingId/cross-post': typeof DashboardCrosspostingListingIdCrossPostRoute
  '/dashboard/crossposting/$listingId/facebook': typeof DashboardCrosspostingListingIdFacebookRoute
  '/dashboard/crossposting/$listingId/instagram': typeof DashboardCrosspostingListingIdInstagramRoute
  '/dashboard/crossposting/$listingId/overview': typeof DashboardCrosspostingListingIdOverviewRoute
  '/dashboard/events/$eventId/edit': typeof DashboardEventsEventIdEditRoute
  '/dashboard/events/$eventId/requests': typeof DashboardEventsEventIdRequestsRoute
  '/dashboard/events/$eventId/tickets': typeof DashboardEventsEventIdTicketsRoute
  '/dashboard/listings/$listingId/edit': typeof DashboardListingsListingIdEditRoute
  '/dashboard/crossposting/$listingId/': typeof DashboardCrosspostingListingIdIndexRoute
  '/dashboard/events/$eventId/': typeof DashboardEventsEventIdIndexRoute
  '/dashboard/listings/$listingId/': typeof DashboardListingsListingIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/admin'
    | '/admin-login'
    | '/dashboard'
    | '/forgot-password'
    | '/login'
    | '/register'
    | '/reset-password'
    | '/setup-account'
    | '/upgrade'
    | '/admin/ai-costs'
    | '/admin/channel'
    | '/admin/content-reports'
    | '/admin/download-links'
    | '/admin/drops'
    | '/admin/invite-business'
    | '/admin/map'
    | '/admin/moderation'
    | '/admin/opportunities'
    | '/admin/share-cashback'
    | '/admin/signups'
    | '/admin/stats'
    | '/dashboard/actions'
    | '/dashboard/business'
    | '/dashboard/earnings'
    | '/dashboard/groups'
    | '/dashboard/menu'
    | '/dashboard/organizer'
    | '/dashboard/settings'
    | '/dashboard/subscription'
    | '/setup/company'
    | '/setup/profile'
    | '/admin/'
    | '/dashboard/'
    | '/admin/partners/$partnerId'
    | '/dashboard/ai-studio/edit-picture'
    | '/dashboard/ai-studio/event-creator'
    | '/dashboard/ai-studio/flyer'
    | '/dashboard/ai-studio/format-converter'
    | '/dashboard/ai-studio/qr'
    | '/dashboard/ai-studio/refine'
    | '/dashboard/business/edit'
    | '/dashboard/events/create'
    | '/dashboard/listings/create'
    | '/admin/partners/'
    | '/dashboard/ai-studio/'
    | '/dashboard/crossposting/'
    | '/dashboard/events/'
    | '/dashboard/listings/'
    | '/dashboard/media/'
    | '/dashboard/crossposting/$listingId/connect'
    | '/dashboard/crossposting/$listingId/cross-post'
    | '/dashboard/crossposting/$listingId/facebook'
    | '/dashboard/crossposting/$listingId/instagram'
    | '/dashboard/crossposting/$listingId/overview'
    | '/dashboard/events/$eventId/edit'
    | '/dashboard/events/$eventId/requests'
    | '/dashboard/events/$eventId/tickets'
    | '/dashboard/listings/$listingId/edit'
    | '/dashboard/crossposting/$listingId/'
    | '/dashboard/events/$eventId/'
    | '/dashboard/listings/$listingId/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/admin-login'
    | '/forgot-password'
    | '/login'
    | '/register'
    | '/reset-password'
    | '/setup-account'
    | '/upgrade'
    | '/admin/ai-costs'
    | '/admin/channel'
    | '/admin/content-reports'
    | '/admin/download-links'
    | '/admin/drops'
    | '/admin/invite-business'
    | '/admin/map'
    | '/admin/moderation'
    | '/admin/opportunities'
    | '/admin/share-cashback'
    | '/admin/signups'
    | '/admin/stats'
    | '/dashboard/actions'
    | '/dashboard/business'
    | '/dashboard/earnings'
    | '/dashboard/groups'
    | '/dashboard/menu'
    | '/dashboard/organizer'
    | '/dashboard/settings'
    | '/dashboard/subscription'
    | '/setup/company'
    | '/setup/profile'
    | '/admin'
    | '/dashboard'
    | '/admin/partners/$partnerId'
    | '/dashboard/ai-studio/edit-picture'
    | '/dashboard/ai-studio/event-creator'
    | '/dashboard/ai-studio/flyer'
    | '/dashboard/ai-studio/format-converter'
    | '/dashboard/ai-studio/qr'
    | '/dashboard/ai-studio/refine'
    | '/dashboard/business/edit'
    | '/dashboard/events/create'
    | '/dashboard/listings/create'
    | '/admin/partners'
    | '/dashboard/ai-studio'
    | '/dashboard/crossposting'
    | '/dashboard/events'
    | '/dashboard/listings'
    | '/dashboard/media'
    | '/dashboard/crossposting/$listingId/connect'
    | '/dashboard/crossposting/$listingId/cross-post'
    | '/dashboard/crossposting/$listingId/facebook'
    | '/dashboard/crossposting/$listingId/instagram'
    | '/dashboard/crossposting/$listingId/overview'
    | '/dashboard/events/$eventId/edit'
    | '/dashboard/events/$eventId/requests'
    | '/dashboard/events/$eventId/tickets'
    | '/dashboard/listings/$listingId/edit'
    | '/dashboard/crossposting/$listingId'
    | '/dashboard/events/$eventId'
    | '/dashboard/listings/$listingId'
  id:
    | '__root__'
    | '/'
    | '/admin'
    | '/admin-login'
    | '/dashboard'
    | '/forgot-password'
    | '/login'
    | '/register'
    | '/reset-password'
    | '/setup-account'
    | '/upgrade'
    | '/admin/ai-costs'
    | '/admin/channel'
    | '/admin/content-reports'
    | '/admin/download-links'
    | '/admin/drops'
    | '/admin/invite-business'
    | '/admin/map'
    | '/admin/moderation'
    | '/admin/opportunities'
    | '/admin/share-cashback'
    | '/admin/signups'
    | '/admin/stats'
    | '/dashboard/actions'
    | '/dashboard/business'
    | '/dashboard/earnings'
    | '/dashboard/groups'
    | '/dashboard/menu'
    | '/dashboard/organizer'
    | '/dashboard/settings'
    | '/dashboard/subscription'
    | '/setup/company'
    | '/setup/profile'
    | '/admin/'
    | '/dashboard/'
    | '/admin/partners/$partnerId'
    | '/dashboard/ai-studio/edit-picture'
    | '/dashboard/ai-studio/event-creator'
    | '/dashboard/ai-studio/flyer'
    | '/dashboard/ai-studio/format-converter'
    | '/dashboard/ai-studio/qr'
    | '/dashboard/ai-studio/refine'
    | '/dashboard/business/edit'
    | '/dashboard/events/create'
    | '/dashboard/listings/create'
    | '/admin/partners/'
    | '/dashboard/ai-studio/'
    | '/dashboard/crossposting/'
    | '/dashboard/events/'
    | '/dashboard/listings/'
    | '/dashboard/media/'
    | '/dashboard/crossposting/$listingId/connect'
    | '/dashboard/crossposting/$listingId/cross-post'
    | '/dashboard/crossposting/$listingId/facebook'
    | '/dashboard/crossposting/$listingId/instagram'
    | '/dashboard/crossposting/$listingId/overview'
    | '/dashboard/events/$eventId/edit'
    | '/dashboard/events/$eventId/requests'
    | '/dashboard/events/$eventId/tickets'
    | '/dashboard/listings/$listingId/edit'
    | '/dashboard/crossposting/$listingId/'
    | '/dashboard/events/$eventId/'
    | '/dashboard/listings/$listingId/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AdminRoute: typeof AdminRouteWithChildren
  AdminLoginRoute: typeof AdminLoginRoute
  DashboardRoute: typeof DashboardRouteWithChildren
  ForgotPasswordRoute: typeof ForgotPasswordRoute
  LoginRoute: typeof LoginRoute
  RegisterRoute: typeof RegisterRoute
  ResetPasswordRoute: typeof ResetPasswordRoute
  SetupAccountRoute: typeof SetupAccountRoute
  UpgradeRoute: typeof UpgradeRoute
  SetupCompanyRoute: typeof SetupCompanyRoute
  SetupProfileRoute: typeof SetupProfileRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/upgrade': {
      id: '/upgrade'
      path: '/upgrade'
      fullPath: '/upgrade'
      preLoaderRoute: typeof UpgradeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/setup-account': {
      id: '/setup-account'
      path: '/setup-account'
      fullPath: '/setup-account'
      preLoaderRoute: typeof SetupAccountRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reset-password': {
      id: '/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof ResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/register': {
      id: '/register'
      path: '/register'
      fullPath: '/register'
      preLoaderRoute: typeof RegisterRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forgot-password': {
      id: '/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof ForgotPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard': {
      id: '/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof DashboardRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin-login': {
      id: '/admin-login'
      path: '/admin-login'
      fullPath: '/admin-login'
      preLoaderRoute: typeof AdminLoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin': {
      id: '/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AdminRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard/': {
      id: '/dashboard/'
      path: '/'
      fullPath: '/dashboard/'
      preLoaderRoute: typeof DashboardIndexRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/admin/': {
      id: '/admin/'
      path: '/'
      fullPath: '/admin/'
      preLoaderRoute: typeof AdminIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/setup/profile': {
      id: '/setup/profile'
      path: '/setup/profile'
      fullPath: '/setup/profile'
      preLoaderRoute: typeof SetupProfileRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/setup/company': {
      id: '/setup/company'
      path: '/setup/company'
      fullPath: '/setup/company'
      preLoaderRoute: typeof SetupCompanyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard/subscription': {
      id: '/dashboard/subscription'
      path: '/subscription'
      fullPath: '/dashboard/subscription'
      preLoaderRoute: typeof DashboardSubscriptionRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/settings': {
      id: '/dashboard/settings'
      path: '/settings'
      fullPath: '/dashboard/settings'
      preLoaderRoute: typeof DashboardSettingsRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/organizer': {
      id: '/dashboard/organizer'
      path: '/organizer'
      fullPath: '/dashboard/organizer'
      preLoaderRoute: typeof DashboardOrganizerRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/menu': {
      id: '/dashboard/menu'
      path: '/menu'
      fullPath: '/dashboard/menu'
      preLoaderRoute: typeof DashboardMenuRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/groups': {
      id: '/dashboard/groups'
      path: '/groups'
      fullPath: '/dashboard/groups'
      preLoaderRoute: typeof DashboardGroupsRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/earnings': {
      id: '/dashboard/earnings'
      path: '/earnings'
      fullPath: '/dashboard/earnings'
      preLoaderRoute: typeof DashboardEarningsRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/business': {
      id: '/dashboard/business'
      path: '/business'
      fullPath: '/dashboard/business'
      preLoaderRoute: typeof DashboardBusinessRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/actions': {
      id: '/dashboard/actions'
      path: '/actions'
      fullPath: '/dashboard/actions'
      preLoaderRoute: typeof DashboardActionsRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/admin/stats': {
      id: '/admin/stats'
      path: '/stats'
      fullPath: '/admin/stats'
      preLoaderRoute: typeof AdminStatsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/signups': {
      id: '/admin/signups'
      path: '/signups'
      fullPath: '/admin/signups'
      preLoaderRoute: typeof AdminSignupsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/share-cashback': {
      id: '/admin/share-cashback'
      path: '/share-cashback'
      fullPath: '/admin/share-cashback'
      preLoaderRoute: typeof AdminShareCashbackRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/opportunities': {
      id: '/admin/opportunities'
      path: '/opportunities'
      fullPath: '/admin/opportunities'
      preLoaderRoute: typeof AdminOpportunitiesRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/moderation': {
      id: '/admin/moderation'
      path: '/moderation'
      fullPath: '/admin/moderation'
      preLoaderRoute: typeof AdminModerationRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/map': {
      id: '/admin/map'
      path: '/map'
      fullPath: '/admin/map'
      preLoaderRoute: typeof AdminMapRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/invite-business': {
      id: '/admin/invite-business'
      path: '/invite-business'
      fullPath: '/admin/invite-business'
      preLoaderRoute: typeof AdminInviteBusinessRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/drops': {
      id: '/admin/drops'
      path: '/drops'
      fullPath: '/admin/drops'
      preLoaderRoute: typeof AdminDropsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/download-links': {
      id: '/admin/download-links'
      path: '/download-links'
      fullPath: '/admin/download-links'
      preLoaderRoute: typeof AdminDownloadLinksRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/content-reports': {
      id: '/admin/content-reports'
      path: '/content-reports'
      fullPath: '/admin/content-reports'
      preLoaderRoute: typeof AdminContentReportsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/channel': {
      id: '/admin/channel'
      path: '/channel'
      fullPath: '/admin/channel'
      preLoaderRoute: typeof AdminChannelRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/ai-costs': {
      id: '/admin/ai-costs'
      path: '/ai-costs'
      fullPath: '/admin/ai-costs'
      preLoaderRoute: typeof AdminAiCostsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/dashboard/media/': {
      id: '/dashboard/media/'
      path: '/media'
      fullPath: '/dashboard/media/'
      preLoaderRoute: typeof DashboardMediaIndexRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/listings/': {
      id: '/dashboard/listings/'
      path: '/listings'
      fullPath: '/dashboard/listings/'
      preLoaderRoute: typeof DashboardListingsIndexRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/events/': {
      id: '/dashboard/events/'
      path: '/events'
      fullPath: '/dashboard/events/'
      preLoaderRoute: typeof DashboardEventsIndexRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/crossposting/': {
      id: '/dashboard/crossposting/'
      path: '/crossposting'
      fullPath: '/dashboard/crossposting/'
      preLoaderRoute: typeof DashboardCrosspostingIndexRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/ai-studio/': {
      id: '/dashboard/ai-studio/'
      path: '/ai-studio'
      fullPath: '/dashboard/ai-studio/'
      preLoaderRoute: typeof DashboardAiStudioIndexRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/admin/partners/': {
      id: '/admin/partners/'
      path: '/partners'
      fullPath: '/admin/partners/'
      preLoaderRoute: typeof AdminPartnersIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/dashboard/listings/create': {
      id: '/dashboard/listings/create'
      path: '/listings/create'
      fullPath: '/dashboard/listings/create'
      preLoaderRoute: typeof DashboardListingsCreateRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/events/create': {
      id: '/dashboard/events/create'
      path: '/events/create'
      fullPath: '/dashboard/events/create'
      preLoaderRoute: typeof DashboardEventsCreateRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/business/edit': {
      id: '/dashboard/business/edit'
      path: '/edit'
      fullPath: '/dashboard/business/edit'
      preLoaderRoute: typeof DashboardBusinessEditRouteImport
      parentRoute: typeof DashboardBusinessRoute
    }
    '/dashboard/ai-studio/refine': {
      id: '/dashboard/ai-studio/refine'
      path: '/ai-studio/refine'
      fullPath: '/dashboard/ai-studio/refine'
      preLoaderRoute: typeof DashboardAiStudioRefineRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/ai-studio/qr': {
      id: '/dashboard/ai-studio/qr'
      path: '/ai-studio/qr'
      fullPath: '/dashboard/ai-studio/qr'
      preLoaderRoute: typeof DashboardAiStudioQrRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/ai-studio/format-converter': {
      id: '/dashboard/ai-studio/format-converter'
      path: '/ai-studio/format-converter'
      fullPath: '/dashboard/ai-studio/format-converter'
      preLoaderRoute: typeof DashboardAiStudioFormatConverterRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/ai-studio/flyer': {
      id: '/dashboard/ai-studio/flyer'
      path: '/ai-studio/flyer'
      fullPath: '/dashboard/ai-studio/flyer'
      preLoaderRoute: typeof DashboardAiStudioFlyerRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/ai-studio/event-creator': {
      id: '/dashboard/ai-studio/event-creator'
      path: '/ai-studio/event-creator'
      fullPath: '/dashboard/ai-studio/event-creator'
      preLoaderRoute: typeof DashboardAiStudioEventCreatorRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/ai-studio/edit-picture': {
      id: '/dashboard/ai-studio/edit-picture'
      path: '/ai-studio/edit-picture'
      fullPath: '/dashboard/ai-studio/edit-picture'
      preLoaderRoute: typeof DashboardAiStudioEditPictureRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/admin/partners/$partnerId': {
      id: '/admin/partners/$partnerId'
      path: '/partners/$partnerId'
      fullPath: '/admin/partners/$partnerId'
      preLoaderRoute: typeof AdminPartnersPartnerIdRouteImport
      parentRoute: typeof AdminRoute
    }
    '/dashboard/listings/$listingId/': {
      id: '/dashboard/listings/$listingId/'
      path: '/listings/$listingId'
      fullPath: '/dashboard/listings/$listingId/'
      preLoaderRoute: typeof DashboardListingsListingIdIndexRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/events/$eventId/': {
      id: '/dashboard/events/$eventId/'
      path: '/events/$eventId'
      fullPath: '/dashboard/events/$eventId/'
      preLoaderRoute: typeof DashboardEventsEventIdIndexRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/crossposting/$listingId/': {
      id: '/dashboard/crossposting/$listingId/'
      path: '/crossposting/$listingId'
      fullPath: '/dashboard/crossposting/$listingId/'
      preLoaderRoute: typeof DashboardCrosspostingListingIdIndexRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/listings/$listingId/edit': {
      id: '/dashboard/listings/$listingId/edit'
      path: '/listings/$listingId/edit'
      fullPath: '/dashboard/listings/$listingId/edit'
      preLoaderRoute: typeof DashboardListingsListingIdEditRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/events/$eventId/tickets': {
      id: '/dashboard/events/$eventId/tickets'
      path: '/events/$eventId/tickets'
      fullPath: '/dashboard/events/$eventId/tickets'
      preLoaderRoute: typeof DashboardEventsEventIdTicketsRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/events/$eventId/requests': {
      id: '/dashboard/events/$eventId/requests'
      path: '/events/$eventId/requests'
      fullPath: '/dashboard/events/$eventId/requests'
      preLoaderRoute: typeof DashboardEventsEventIdRequestsRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/events/$eventId/edit': {
      id: '/dashboard/events/$eventId/edit'
      path: '/events/$eventId/edit'
      fullPath: '/dashboard/events/$eventId/edit'
      preLoaderRoute: typeof DashboardEventsEventIdEditRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/crossposting/$listingId/overview': {
      id: '/dashboard/crossposting/$listingId/overview'
      path: '/crossposting/$listingId/overview'
      fullPath: '/dashboard/crossposting/$listingId/overview'
      preLoaderRoute: typeof DashboardCrosspostingListingIdOverviewRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/crossposting/$listingId/instagram': {
      id: '/dashboard/crossposting/$listingId/instagram'
      path: '/crossposting/$listingId/instagram'
      fullPath: '/dashboard/crossposting/$listingId/instagram'
      preLoaderRoute: typeof DashboardCrosspostingListingIdInstagramRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/crossposting/$listingId/facebook': {
      id: '/dashboard/crossposting/$listingId/facebook'
      path: '/crossposting/$listingId/facebook'
      fullPath: '/dashboard/crossposting/$listingId/facebook'
      preLoaderRoute: typeof DashboardCrosspostingListingIdFacebookRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/crossposting/$listingId/cross-post': {
      id: '/dashboard/crossposting/$listingId/cross-post'
      path: '/crossposting/$listingId/cross-post'
      fullPath: '/dashboard/crossposting/$listingId/cross-post'
      preLoaderRoute: typeof DashboardCrosspostingListingIdCrossPostRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/crossposting/$listingId/connect': {
      id: '/dashboard/crossposting/$listingId/connect'
      path: '/crossposting/$listingId/connect'
      fullPath: '/dashboard/crossposting/$listingId/connect'
      preLoaderRoute: typeof DashboardCrosspostingListingIdConnectRouteImport
      parentRoute: typeof DashboardRoute
    }
  }
}

interface AdminRouteChildren {
  AdminAiCostsRoute: typeof AdminAiCostsRoute
  AdminChannelRoute: typeof AdminChannelRoute
  AdminContentReportsRoute: typeof AdminContentReportsRoute
  AdminDownloadLinksRoute: typeof AdminDownloadLinksRoute
  AdminDropsRoute: typeof AdminDropsRoute
  AdminInviteBusinessRoute: typeof AdminInviteBusinessRoute
  AdminMapRoute: typeof AdminMapRoute
  AdminModerationRoute: typeof AdminModerationRoute
  AdminOpportunitiesRoute: typeof AdminOpportunitiesRoute
  AdminShareCashbackRoute: typeof AdminShareCashbackRoute
  AdminSignupsRoute: typeof AdminSignupsRoute
  AdminStatsRoute: typeof AdminStatsRoute
  AdminIndexRoute: typeof AdminIndexRoute
  AdminPartnersPartnerIdRoute: typeof AdminPartnersPartnerIdRoute
  AdminPartnersIndexRoute: typeof AdminPartnersIndexRoute
}

const AdminRouteChildren: AdminRouteChildren = {
  AdminAiCostsRoute: AdminAiCostsRoute,
  AdminChannelRoute: AdminChannelRoute,
  AdminContentReportsRoute: AdminContentReportsRoute,
  AdminDownloadLinksRoute: AdminDownloadLinksRoute,
  AdminDropsRoute: AdminDropsRoute,
  AdminInviteBusinessRoute: AdminInviteBusinessRoute,
  AdminMapRoute: AdminMapRoute,
  AdminModerationRoute: AdminModerationRoute,
  AdminOpportunitiesRoute: AdminOpportunitiesRoute,
  AdminShareCashbackRoute: AdminShareCashbackRoute,
  AdminSignupsRoute: AdminSignupsRoute,
  AdminStatsRoute: AdminStatsRoute,
  AdminIndexRoute: AdminIndexRoute,
  AdminPartnersPartnerIdRoute: AdminPartnersPartnerIdRoute,
  AdminPartnersIndexRoute: AdminPartnersIndexRoute,
}

const AdminRouteWithChildren = AdminRoute._addFileChildren(AdminRouteChildren)

interface DashboardBusinessRouteChildren {
  DashboardBusinessEditRoute: typeof DashboardBusinessEditRoute
}

const DashboardBusinessRouteChildren: DashboardBusinessRouteChildren = {
  DashboardBusinessEditRoute: DashboardBusinessEditRoute,
}

const DashboardBusinessRouteWithChildren =
  DashboardBusinessRoute._addFileChildren(DashboardBusinessRouteChildren)

interface DashboardRouteChildren {
  DashboardActionsRoute: typeof DashboardActionsRoute
  DashboardBusinessRoute: typeof DashboardBusinessRouteWithChildren
  DashboardEarningsRoute: typeof DashboardEarningsRoute
  DashboardGroupsRoute: typeof DashboardGroupsRoute
  DashboardMenuRoute: typeof DashboardMenuRoute
  DashboardOrganizerRoute: typeof DashboardOrganizerRoute
  DashboardSettingsRoute: typeof DashboardSettingsRoute
  DashboardSubscriptionRoute: typeof DashboardSubscriptionRoute
  DashboardIndexRoute: typeof DashboardIndexRoute
  DashboardAiStudioEditPictureRoute: typeof DashboardAiStudioEditPictureRoute
  DashboardAiStudioEventCreatorRoute: typeof DashboardAiStudioEventCreatorRoute
  DashboardAiStudioFlyerRoute: typeof DashboardAiStudioFlyerRoute
  DashboardAiStudioFormatConverterRoute: typeof DashboardAiStudioFormatConverterRoute
  DashboardAiStudioQrRoute: typeof DashboardAiStudioQrRoute
  DashboardAiStudioRefineRoute: typeof DashboardAiStudioRefineRoute
  DashboardEventsCreateRoute: typeof DashboardEventsCreateRoute
  DashboardListingsCreateRoute: typeof DashboardListingsCreateRoute
  DashboardAiStudioIndexRoute: typeof DashboardAiStudioIndexRoute
  DashboardCrosspostingIndexRoute: typeof DashboardCrosspostingIndexRoute
  DashboardEventsIndexRoute: typeof DashboardEventsIndexRoute
  DashboardListingsIndexRoute: typeof DashboardListingsIndexRoute
  DashboardMediaIndexRoute: typeof DashboardMediaIndexRoute
  DashboardCrosspostingListingIdConnectRoute: typeof DashboardCrosspostingListingIdConnectRoute
  DashboardCrosspostingListingIdCrossPostRoute: typeof DashboardCrosspostingListingIdCrossPostRoute
  DashboardCrosspostingListingIdFacebookRoute: typeof DashboardCrosspostingListingIdFacebookRoute
  DashboardCrosspostingListingIdInstagramRoute: typeof DashboardCrosspostingListingIdInstagramRoute
  DashboardCrosspostingListingIdOverviewRoute: typeof DashboardCrosspostingListingIdOverviewRoute
  DashboardEventsEventIdEditRoute: typeof DashboardEventsEventIdEditRoute
  DashboardEventsEventIdRequestsRoute: typeof DashboardEventsEventIdRequestsRoute
  DashboardEventsEventIdTicketsRoute: typeof DashboardEventsEventIdTicketsRoute
  DashboardListingsListingIdEditRoute: typeof DashboardListingsListingIdEditRoute
  DashboardCrosspostingListingIdIndexRoute: typeof DashboardCrosspostingListingIdIndexRoute
  DashboardEventsEventIdIndexRoute: typeof DashboardEventsEventIdIndexRoute
  DashboardListingsListingIdIndexRoute: typeof DashboardListingsListingIdIndexRoute
}

const DashboardRouteChildren: DashboardRouteChildren = {
  DashboardActionsRoute: DashboardActionsRoute,
  DashboardBusinessRoute: DashboardBusinessRouteWithChildren,
  DashboardEarningsRoute: DashboardEarningsRoute,
  DashboardGroupsRoute: DashboardGroupsRoute,
  DashboardMenuRoute: DashboardMenuRoute,
  DashboardOrganizerRoute: DashboardOrganizerRoute,
  DashboardSettingsRoute: DashboardSettingsRoute,
  DashboardSubscriptionRoute: DashboardSubscriptionRoute,
  DashboardIndexRoute: DashboardIndexRoute,
  DashboardAiStudioEditPictureRoute: DashboardAiStudioEditPictureRoute,
  DashboardAiStudioEventCreatorRoute: DashboardAiStudioEventCreatorRoute,
  DashboardAiStudioFlyerRoute: DashboardAiStudioFlyerRoute,
  DashboardAiStudioFormatConverterRoute: DashboardAiStudioFormatConverterRoute,
  DashboardAiStudioQrRoute: DashboardAiStudioQrRoute,
  DashboardAiStudioRefineRoute: DashboardAiStudioRefineRoute,
  DashboardEventsCreateRoute: DashboardEventsCreateRoute,
  DashboardListingsCreateRoute: DashboardListingsCreateRoute,
  DashboardAiStudioIndexRoute: DashboardAiStudioIndexRoute,
  DashboardCrosspostingIndexRoute: DashboardCrosspostingIndexRoute,
  DashboardEventsIndexRoute: DashboardEventsIndexRoute,
  DashboardListingsIndexRoute: DashboardListingsIndexRoute,
  DashboardMediaIndexRoute: DashboardMediaIndexRoute,
  DashboardCrosspostingListingIdConnectRoute:
    DashboardCrosspostingListingIdConnectRoute,
  DashboardCrosspostingListingIdCrossPostRoute:
    DashboardCrosspostingListingIdCrossPostRoute,
  DashboardCrosspostingListingIdFacebookRoute:
    DashboardCrosspostingListingIdFacebookRoute,
  DashboardCrosspostingListingIdInstagramRoute:
    DashboardCrosspostingListingIdInstagramRoute,
  DashboardCrosspostingListingIdOverviewRoute:
    DashboardCrosspostingListingIdOverviewRoute,
  DashboardEventsEventIdEditRoute: DashboardEventsEventIdEditRoute,
  DashboardEventsEventIdRequestsRoute: DashboardEventsEventIdRequestsRoute,
  DashboardEventsEventIdTicketsRoute: DashboardEventsEventIdTicketsRoute,
  DashboardListingsListingIdEditRoute: DashboardListingsListingIdEditRoute,
  DashboardCrosspostingListingIdIndexRoute:
    DashboardCrosspostingListingIdIndexRoute,
  DashboardEventsEventIdIndexRoute: DashboardEventsEventIdIndexRoute,
  DashboardListingsListingIdIndexRoute: DashboardListingsListingIdIndexRoute,
}

const DashboardRouteWithChildren = DashboardRoute._addFileChildren(
  DashboardRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AdminRoute: AdminRouteWithChildren,
  AdminLoginRoute: AdminLoginRoute,
  DashboardRoute: DashboardRouteWithChildren,
  ForgotPasswordRoute: ForgotPasswordRoute,
  LoginRoute: LoginRoute,
  RegisterRoute: RegisterRoute,
  ResetPasswordRoute: ResetPasswordRoute,
  SetupAccountRoute: SetupAccountRoute,
  UpgradeRoute: UpgradeRoute,
  SetupCompanyRoute: SetupCompanyRoute,
  SetupProfileRoute: SetupProfileRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
